import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Hammer, CheckCircle, WarningCircle, CircleNotch, PlusCircle } from '@phosphor-icons/react';

const ForgeDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ accounts: 0, total: 0, live: 0, failed: 0, building: 0, recent: [] });

  useEffect(() => {
    axios.get('/api/forge/dashboard', { withCredentials: true })
      .then(res => setData(res.data))
      .catch(() => {});
  }, []);

  const Stat = ({ label, value, color, testid }) => (
    <div className="bg-card border border-white/10 p-6" data-testid={testid}>
      <div className={`text-4xl font-black ${color}`}>{value}</div>
      <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mt-2">{label}</div>
    </div>
  );

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-black mb-2 text-[#FB503B] flex items-center gap-3"><Hammer size={36} weight="fill" /> ONFORGE</h1>
          <p className="text-slate-400 font-mono">Spin up Laravel Forge sites with free on-forge.com URLs.</p>
        </div>
        <button onClick={() => navigate('/forge/deployments/new')} data-testid="forge-dash-new-btn" className="flex items-center gap-2 bg-[#FB503B] text-white px-4 py-2 font-bold hover:bg-[#e0402d] transition-colors">
          <PlusCircle size={20} /> New Deployment
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <Stat label="Accounts" value={data.accounts} color="text-white" testid="forge-stat-accounts" />
        <Stat label="Total Sites" value={data.total} color="text-white" testid="forge-stat-total" />
        <Stat label="Live" value={data.live} color="text-[#39FF14]" testid="forge-stat-live" />
        <Stat label="Building" value={data.building} color="text-yellow-400" testid="forge-stat-building" />
        <Stat label="Failed" value={data.failed} color="text-red-500" testid="forge-stat-failed" />
      </div>

      <div className="bg-card border border-white/10 overflow-hidden">
        <div className="p-4 border-b border-white/10 bg-black/20">
          <h3 className="font-bold uppercase tracking-wider text-[#FB503B]">Recent Sites</h3>
        </div>
        <table className="w-full text-left text-sm">
          <tbody>
            {data.recent.map(d => (
              <tr key={d.id} className="border-b border-white/5">
                <td className="p-4 font-mono font-bold">{d.site_name}</td>
                <td className="p-4">
                  {d.status === 'live' ? <span className="text-[#39FF14] flex items-center gap-1"><CheckCircle /> live</span>
                    : d.status === 'failed' ? <span className="text-red-500 flex items-center gap-1"><WarningCircle /> failed</span>
                    : <span className="text-yellow-400 flex items-center gap-1"><CircleNotch className="animate-spin" /> {d.status}</span>}
                </td>
                <td className="p-4 font-mono text-slate-400 truncate max-w-xs">{d.public_url || '-'}</td>
              </tr>
            ))}
            {data.recent.length === 0 && (
              <tr><td colSpan="3" className="p-8 text-center text-slate-500">No sites yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ForgeDashboard;
